import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { SmartForm } from 'app/components/ui/smart-form'
import { FormInput } from 'app/components/ui/form-input'
import { Button } from 'app/components/ui/button'
import { AppearanceSection } from './AppearanceSection'
import { profileValidator } from './profileValidator'
import type { ProfileUser } from './useProfile'

export type ProfileShadcnComponentProps = {
  user: ProfileUser
  saving: boolean
  roleName: string
  onSubmit: (data: { name: string; email: string }) => void
}

export function ProfileShadcnComponent({ user, saving, roleName, onSubmit }: ProfileShadcnComponentProps) {
  return (
    <div className="max-w-[600px]">
      <PageHeaderComponent title="Profile" />
      <div className="p-4">
        <SmartForm
          id="profile-form"
          validator={profileValidator}
          defaultValues={{ name: user.name || ``, email: user.email || `` }}
          onSubmit={(data) => onSubmit(data as { name: string; email: string })}
          preventSubmit
          hideButtons
        >
          <FormInput cols={6} name="name" label="Name" />
          <FormInput cols={6} name="email" label="Email" disabled />
          <FormInput cols={6} name="role" label="Role" value={roleName} disabled />
          <div className="col-span-6 flex justify-end gap-4">
            <div className="grow" />
            <Button type="submit" variant="primary" size="md" loading={saving}>
              Save
            </Button>
          </div>
        </SmartForm>
      </div>
      <div className="px-4 pb-4">
        <AppearanceSection />
      </div>
    </div>
  )
}
